import { __extends, __assign } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-input.css';
import { UitkInput } from './uitk-input.esm.js';
var getClassNameList = classNames.bind(styles);
var PasswordInput = /** @class */function (_super) {
  __extends(PasswordInput, _super);
  function PasswordInput(props) {
    var _this = _super.call(this, props) || this;
    var passwordVisible = _this.props.passwordVisible;
    _this.state = {
      passwordVisible: passwordVisible
    };
    _this.togglePasswordVisibility = _this.togglePasswordVisibility.bind(_this);
    return _this;
  }
  PasswordInput.prototype.componentDidUpdate = function (prevProps) {
    var passwordVisible = this.props.passwordVisible;
    if (prevProps.passwordVisible !== passwordVisible) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        passwordVisible: passwordVisible
      });
    }
  };
  PasswordInput.prototype.togglePasswordVisibility = function () {
    var passwordVisible = this.state.passwordVisible;
    var isPasswordVisible = !passwordVisible;
    this.setState({
      passwordVisible: isPasswordVisible
    });
  };
  PasswordInput.prototype.render = function () {
    var l10n = this.props.l10n;
    var passwordVisible = this.state.passwordVisible;
    return React.createElement(UitkInput, __assign({}, this.props, {
      type: passwordVisible ? 'text' : 'password',
      hasClearButton: false,
      className: getClassNameList('uitk-password-visibility-input', 'has-input-cta')
    }), React.createElement("button", {
      className: getClassNameList('uitk-password-visibility-button', 'uitk-input-cta'),
      onClick: this.togglePasswordVisibility,
      type: "button"
    }, React.createElement("span", {
      className: getClassNameList('is-visually-hidden')
    }, passwordVisible ? l10n.formatText('password.hide') : l10n.formatText('password.show')), passwordVisible ? React.createElement(UitkIcon, {
      name: "visibility_off",
      size: UitkIconSize.SMALL
    }) : React.createElement(UitkIcon, {
      name: "visibility",
      size: UitkIconSize.SMALL
    })));
  };
  PasswordInput.displayName = 'UitkPasswordInput';
  return PasswordInput;
}(React.Component);
var UitkPasswordInput = function (props) {
  var l10n = useLocalization();
  return React.createElement(PasswordInput, __assign({
    l10n: l10n
  }, props));
};
export { UitkPasswordInput };